<template>
  <v-dialog
    v-model="dialog"
    width="420px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <h3>Official Policy</h3>
          <i
            class="el-icon-close"
            @click="dialog=false"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="form-item">
            <span>Official Policy</span>
            <el-form-item
              ref="pcy_pdf_path_id"
              prop="pcy_pdf_path_id">
              <v-upload
                :card="true"
                :fileData="formData.pcy_pdf"
                :edit="true"
                @delete="handlerDeleteFile"
                @uploadSuccess="handlerUploadSuccess"
              />
            </el-form-item>
          </div>
          <div
            class="form-item">
            <span>Policy No.</span>
            <el-form-item
              ref="pcy_no"
              prop="pcy_no">
              <v-input v-model="formData.pcy_no" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="dialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="onContinue">Continue</v-button>
      </div>
    </div>

  </v-dialog>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {updateOrderFilePcy} from '@/api/order'

export default {
  name: 'OfficialPolicyDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    changeUploadData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      formData: {
        pcy_no: '',
        pcy_pdf: null,
        pcy_pdf_path: '',
        pcy_pdf_path_id: '',
      },
      extraRules: {
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        date: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        pcy_pdf_path_id: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        if(!val) {
          this.formData = {
            pcy_no: '',
            pcy_pdf: null,
            pcy_pdf_path: '',
            pcy_pdf_path_id: '',
          }
        }
        else {
          const { pcy_no } = this.form
          const { file } = this.changeUploadData
          const {path,id} = file||{}
          this.formData.pcy_pdf = file
          this.formData.pcy_pdf_path_id = id
          this.formData.pcy_pdf_path = path
          if(pcy_no) {
            this.formData.pcy_no = pcy_no
          }
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerUploadSuccess({ data, result }) {
      this.$set(this.formData, 'pcy_pdf', data)
      this.$set(this.formData, 'pcy_pdf_path_id', data.id)
      this.$set(this.formData, 'pcy_pdf_path', data.path)
      this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
    },
    handlerDeleteFile() {
      this.$set(this.formData, 'pcy_pdf', null)
      this.$set(this.formData, 'pcy_pdf_path_id', '')
      this.$set(this.formData, 'pcy_pdf_path', '')
      this.$refs['form'].clearValidate(['pcy_pdf_path_id'])
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.network().updateOrderFilePcy()
        }
        else {
          console.log(rules)
        }
      })
    },
    network() {
      return {
        updateOrderFilePcy: async () => {
          let params = {
            order_id: this.orderId,
            ...this.formData
          }

          const { data } = await updateOrderFilePcy(params)

          this.dialog = false
          this.$emit('success', this.formData)

        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      //padding: 15px;
  .plan-header {
    //padding: 15px;
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
      h3{
        padding-bottom: 0;
      }
    }
  }
      .dialog-footer {
        //margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
  .dialog-body{
    padding: 15px;
  }
    }
</style>
